import React from 'react';
import { Tab, Tabs } from '@mui/material';
import useTranslate from '../../../../customHooks/useTranslate';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import { ZitoneoContentType } from '../../types/zitoneoServicesTypes';

const ZitoneoContentTypeTabs = () => {
    const translate = useTranslate();
    const { visibleContentType, handleVisibleContentType } = useZitoneoUI();

    return (
        <div className='editor__tabs-container'>
            <Tabs
                value={visibleContentType}
                onChange={(_, contentType: ZitoneoContentType) =>
                    handleVisibleContentType(contentType)
                }
                aria-label={translate('content')}
                sx={{ minHeight: '32px' }}
            >
                <Tab
                    value={ZitoneoContentType.SERVICES}
                    label={translate(ZitoneoContentType.SERVICES)}
                    sx={{ minHeight: '32px' }}
                />
                <Tab
                    value={ZitoneoContentType.IMAGES}
                    label={translate(ZitoneoContentType.IMAGES)}
                    sx={{ minHeight: '32px' }}
                />
            </Tabs>
        </div>
    );
};

export default ZitoneoContentTypeTabs;
